var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIi0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9457 11.8801C12.9457 12.8744 12.1465 13.6801 11.1601 13.6801C10.1737 13.6801 9.37451 12.8744 9.37451 11.8801C9.37451 10.8865 10.1737 10.0801 11.1601 10.0801C12.1465 10.0801 12.9457 10.8865 12.9457 11.8801ZM12.9601 15.1201H9.36011V26.6401H12.9601V15.1201ZM18.7071 15.1201H15.1302V26.6401H18.7079V20.5928C18.7079 17.2304 23.0487 16.9554 23.0487 20.5928V26.6401H26.6401V19.3458C26.6401 13.6722 20.2163 13.8788 18.7071 16.6717V15.1201Z",
    fill: "#160404"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.28,
    height: 17.28,
    fill: "white",
    transform: "translate(9.36011 9.35938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIi0);
export default __webpack_public_path__ + "static/media/ii0.4211074411ff001ffd444e136838129b.svg";
export { ForwardRef as ReactComponent };